module.exports = __webpack_public_path__ + "img/work-weixin-light.71f0080f.png";